import React from 'react';
import { searchCustomers } from 'utils/CustomersAPIUtils';
import { FilterAutocompleteEditor } from '../molecules/FilterAutocompleteEditor';
function getCustomerName(item) {
    switch (item._type) {
        case 'Partner':
        case 'Carrier':
            return item.name || '';
        case 'Shipper':
        case 'Vendor':
            return item.company_name || '';
        default:
            return (item.name ||
                item.company_name ||
                `${item.first_name || ''} ${item.last_name || ''}`.trim());
    }
}
/**
 * Build a customer-search filter config. Uses inline autocomplete so nested
 * popover clicks (inside the chip popover) work cleanly.
 */
function customerFilter(id, label, customerType, options = {}) {
    var _a;
    const search = async (query) => {
        const results = (await searchCustomers({
            queryText: query,
            customerTypes: [customerType],
        }));
        return results.sort((a, b) => getCustomerName(a).localeCompare(getCustomerName(b)));
    };
    return {
        id,
        label,
        kind: 'autocomplete-multi',
        initialValue: [],
        toApiParam: { name: (_a = options.apiParam) !== null && _a !== void 0 ? _a : id },
        render: (ctx) => {
            var _a;
            return (React.createElement(FilterAutocompleteEditor, { onSearch: search, toItem: (c) => ({
                    id: c._id,
                    label: getCustomerName(c),
                    description: c.email || c._type,
                }), value: ctx.value || [], labels: ctx.labels, onAdd: ctx.onAdd, onRemove: ctx.onRemove, placeholder: (_a = options.placeholder) !== null && _a !== void 0 ? _a : `Search for ${label}...` }));
        },
    };
}
export const carrierFilter = (id = 'carrier', label = 'Carrier') => customerFilter(id, label, 'carriers');
export const shipperFilter = (id = 'shipper', label = 'Shipper') => customerFilter(id, label, 'shippers');
export const masterAccountFilter = (id = 'master_shipper', label = 'Master Account') => customerFilter(id, label, 'master_shippers');
export const driverFilter = (id = 'driver', label = 'Driver') => customerFilter(id, label, 'drivers');
